import { gql } from "@urql/core";

// ============================================
// Messenger Queries
// ============================================

export const LOG_IN_MESSENGER_MUTATION = gql`
  mutation initiateMessengerAuth {
    initiateMessengerAuth {
      token
      config {
        base_url
        dev_server
        host
        conference
      }
    }
  }
`;

export const GET_CHAT_ROOM_QUERY = gql`
  query getChatRoom($input: GetChatRoomInput!) {
    getChatRoom(input: $input) {
      name
    }
  }
`;

export const LIST_ORG_CHAT_ROOMS_QUERY = gql`
  query listChatRooms($input: ListChatRoomsInput!) {
    listChatRooms(input: $input) {
      name # ID formatted as <APP_ID>_<VITALL_CHAT_ROOM_ID>
      title # Chat room name (patient's full name)
      description # Will populate with patient's email as an extra identifier
    }
  }
`;

// ============================================
// Messenger Mutations
// ============================================

export const BROADCAST_MESSAGE_MUTATION = gql`
  mutation broadcastChatAnnouncement($input: BroadcastChatAnnouncementInput!) {
    broadcastChatAnnouncement(input: $input) {
      total
      queued
      failed
    }
  }
`;

// ===================================================
// TypeScript Types: Get chat token, config, and room
// ===================================================

/**
 * Get chat room query response
 */

export interface ChatConfiguration {
  base_url: string;
  dev_server: string;
  host: string;
  conference: string;
}

export interface ChatTokenAndConfig {
  token: string;
  config: ChatConfiguration;
}

export interface PostMessengerLoginResponse {
  initiateMessengerAuth: ChatTokenAndConfig;
}

export interface GetChatRoomInput {
  fhir_patient_id: string;
}

export interface GetChatRoomResponse {
  getChatRoom: ChatRoomModel;
}

// ===================================================
// TypeScript Types: List chat rooms to broadcast
// ===================================================

/**
 * Broadcast message input
 * Either pass in account_id or chat_room_ids
 */
export interface BroadcastChatAnnouncementInput {
  account_id?: string;
  sender_name?: string | null;
  chat_room_ids?: string[];
  message: string;
}

export interface BroadcastChatAnnouncementResponse {
  broadcastChatAnnouncement: {
    total: number;
    queued: number;
    failed: number;
  };
}

/**
 * List chat rooms input
 *
 * Optional FHIR clinic and practitioner filters
 * If no filters are provided, all active chat rooms within an org are returned
 */
export interface ListChatRoomsInput {
  fhir_clinic_ids?: string[]; // ['Organization/123']
  fhir_practitioner_ids?: string[]; // ['Practitioner/456']
}

/**
 * List chat room query response
 */
export interface ListChatRoomsResponse {
  listChatRooms: ChatRoomModel[];
}

export interface ChatRoomModel {
  description: string; // Patient's email as an extra identifier
  name: string; // <APP_ID>_<CHAT_ROOM_ID>
  title: string; // Patient's full name
}

// ===================================================
// TypeScript Types: Other
// ===================================================

/*
{
  "name":"CombinedError",
  "graphQLErrors":[
    {
      "name":"GraphQLError",
      "originalError":{
        "message":"User 123 is not apart of fhir patient 456's chat room",
        "code":"400"
      },
      "extensions":{},
      "message":"User 123 is not apart of fhir patient 456's chat room"
    }
  ]
}
*/
export interface ChatGraphQLError {
  code: string; // graphQLErrors.at(0).originalError.code
  message: string; // graphQLErrors.at(0).originalError.message
}
